// Angular
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
// RxJS
import { Observable } from 'rxjs';
import { NbAuthService } from '@nebular/auth';
import { tap } from 'rxjs/operators';


@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private router: Router, private authService: NbAuthService) { }

    // canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
		// if (this.authService.isAuthenticated()) {
		// 	return true;
		// } else {
		// 	this.router.navigateByUrl('/auth/login');
		// 	return false;
		// }
    // }
    canActivate() {
      return this.authService.isAuthenticated()
        .pipe(
          tap(authenticated => {
            if (!authenticated) {
              this.router.navigate(['auth/login']);
            }
          }),
        );
    }
}
